import { useEffect, useReducer } from 'react';
import { addDays, addMonths, format, startOfWeek, startOfYear } from 'date-fns';
import { enGB, enUS } from 'date-fns/locale';
/**
 * Hook to get locale and calendar data.
 * @param localeOnly Whether just set the locale i.e. when month/day names are not required.
 */
const UseCalendar = (localeOnly = false) => {
    /**
     * The state reducer.
     */
    const [state, setState] = useReducer((state, values) => {
        return Object.assign(Object.assign({}, state), values);
    }, {
        locale: enUS,
        longMonths: [],
        shortDays: [],
    });
    // Sets the locale, longMonth and shortDay names in state using the browser language.
    // Defaults to en-US.
    useEffect(() => {
        // Default to en-US.
        let localeToUse = enUS;
        // Set locale based on the priority language in the browser.
        switch (navigator.language.toLowerCase()) {
            case 'en-gb':
                localeToUse = enGB;
                break;
            default:
                break;
        }
        // Generate short day and long month names;
        if (!localeOnly) {
            const startDate = new Date();
            // Work out short days of week.
            const monday = startOfWeek(startDate, { weekStartsOn: 1 });
            const days = [...Array(7)].map((_, i) => format(addDays(monday, i), 'EEE', { locale: localeToUse }));
            // Work out long months of year.
            const january = startOfYear(monday);
            const months = [...Array(12)].map((_, i) => format(addMonths(january, i), 'MMMM', { locale: localeToUse }));
            setState({ locale: localeToUse, longMonths: months, shortDays: days });
        }
    }, []);
    return Object.assign({}, state);
};
export default UseCalendar;
